import React from 'react';
import './Refrigerator.css';
import refrige from '../../../imgs/refrigerat.webp';


const Refrigerator = () => {
    return (
        <div className="Material-container">
            <div className='Materialsl'>
                <p className="Material-date">Suitable for daily necessities such as
                    transparent wine packaging boxes, refrigerator storage boxes, candy biscuit
                    packaging containers, plastic bowls and water scoops, etc.</p>
                <div className="advantpl">
                    <img src={refrige} alt="72 Cavity PET Preforms Machine" className="advantpla-image" />
                </div>
                <p className="Material-text">Join us and learn more about how we can solve
                     your injection molding and extrusion blow molding problem.</p>
                <p className="Material-text">See you in Düsseldorf, 19-26 October!</p>
                <p className="Material-text">Come and meet us at Booth D39 in Hall 13.</p>


            </div>
        </div>
    );
};
export default Refrigerator;
